import 'css-chunksrc/client/scenes/projectExpenseEdition/form/expenseTypeSelect/expenseTypeIcon/styles.scss';export default {
  "tag": "_tag_jyeni_1",
  "expenseIcon": "_expenseIcon_jyeni_13",
  "closedTag": "_closedTag_jyeni_19",
  "icon": "_icon_jyeni_30",
  "light": "_light_jyeni_43"
};